import React, { useState } from "react";
import "./contactUs.css";
import { FaEnvelope, FaLocationDot } from "react-icons/fa6";
import { FaPhoneAlt } from "react-icons/fa";
import { toast } from "sonner";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import emailjs from "@emailjs/browser";
import Particles from "../Particles/Particles";

const ContactForm = () => {
  const [loading, setLoading] = useState(false);

  const initialValues = {
    name: "",
    email: "",
    phone: "",
    address: "",
    message: "",
  };

  const validationSchema = Yup.object().shape({
    name: Yup.string().required("Required!"),
    email: Yup.string().email("Invalid email").required("Required!"),
    phone: Yup.string()
      .matches(/^9\d{9}$/, "Must start with 9 and be exactly 10 digits")
      .required("Required!"),
    address: Yup.string().required("Required!"),
    message: Yup.string().required("Required!"),
  });

  const onSubmit = (values, { resetForm }) => {
    setLoading(true);
    emailjs
      .send(
        "service_6ujn2di",
        "template_8b90y5m",
        {
          from_name: values.name,
          from_email: values.email,
          phone: values.phone,
          address: values.address,
          message: values.message,
        },
        "EKfcC2csrw8HLCvXk"
      )
      .then(
        () => {
          setLoading(false);
          toast.success(
            `Thank you ${values.name} for contacting us! We will get back to you soon.`
          );
          resetForm();
        },
        () => {
          setLoading(false);
          toast.error("Failed to contact us. Please try again.");
        }
      );
  };

  return (
    <div className="contact-page">
      {/* Hero Section */}
      <Particles title="Contact Us" />

      {/* Contact Details Section */}
      <div className="container mb-5">
        <div className="text-center my-5">
          <h1 className="display-3 fw-bold">Reach Out to Us</h1>
        </div>

        <div className="row g-4">
          {/* Location Card */}
          <div className="col-md-4">
            <div className="card h-100">
              <div className="card-body text-center">
                <div className="rounded-circle p-3 mb-3">
                  <FaLocationDot />
                </div>
                <div className="text-start">
                  <h3 className="mb-3">Our Location</h3>
                  <p className="text-muted mb-0">
                    4th floor, Computer Bazaar <br />
                    Putalisadak, Kathmandu
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Email Card */}
          <div className="col-md-4">
            <div className="card h-100">
              <div className="card-body text-center">
                <div className="rounded-circle p-3 mb-3">
                  <FaEnvelope />
                </div>
                <div className="text-start">
                  <h3 className="mb-3">Email Us</h3>
                  <p className="text-muted mb-0">
                    <a
                      href="mailto:educrafteducationnetwork@gmail.com"
                      className="text-decoration-none text-muted"
                    >
                      educrafteducationnetwork@gmail.com
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Phone Card */}
          <div className="col-md-4">
            <div className="card h-100">
              <div className="card-body text-center">
                <div className="rounded-circle p-3 mb-3">
                  <FaPhoneAlt />
                </div>
                <div className="text-start">
                  <h3 className="mb-3">Phone</h3>
                  <p className="text-muted mb-0">
                    <a
                      href="tel:01-4500066"
                      className="text-decoration-none text-muted"
                    >
                      01-4500066
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Contact Form Section */}
      <div className="container form-container mb-5">
        <div className="row">
          <div className="col-lg-6">
            <h2 className="help-text mb-4">How can we help you?</h2>
            <p className="text-muted mb-4">
              Please note that you're writing to{" "}
              <strong>Educraft Education Network</strong>. Fill up the form and
              our team will get back to you within 24 hours.
            </p>

            <Formik
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={onSubmit}
            >
              {() => (
                <Form>
                  <div className="row g-3">
                    <div className="col-md-6">
                      <Field
                        type="text"
                        className="form-control"
                        name="name"
                        placeholder="Name*"
                      />
                      <ErrorMessage
                        name="name"
                        component="div"
                        className="text-danger"
                      />
                    </div>

                    <div className="col-md-6">
                      <Field
                        type="email"
                        className="form-control"
                        name="email"
                        placeholder="Email*"
                      />
                      <ErrorMessage
                        name="email"
                        component="div"
                        className="text-danger"
                      />
                    </div>

                    <div className="col-md-6">
                      <Field
                        type="tel"
                        className="form-control"
                        name="phone"
                        placeholder="Phone*"
                      />
                      <ErrorMessage
                        name="phone"
                        component="div"
                        className="text-danger"
                      />
                    </div>

                    <div className="col-md-6">
                      <Field
                        type="text"
                        className="form-control"
                        name="address"
                        placeholder="Address*"
                      />
                      <ErrorMessage
                        name="address"
                        component="div"
                        className="text-danger"
                      />
                    </div>

                    <div className="col-12">
                      <Field
                        as="textarea"
                        rows={4}
                        className="w-100 message-box"
                        name="message"
                        placeholder="Message*"
                      />
                      <ErrorMessage
                        name="message"
                        component="div"
                        className="text-danger"
                      />
                    </div>

                    <div className="col-12">
                      <button
                        type="submit"
                        className="btn px-4 btn-lg"
                        style={{
                          background: "var(--main_color)",
                          color: "#fff",
                        }}
                        disabled={loading}
                      >
                        {loading && (
                          <span className="spinner-border spinner-border-sm me-2"></span>
                        )}
                        Send Message
                      </button>
                    </div>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
          <div className="col-lg-6 mt-4 mt-lg-0">
            <div className="map-container">
              <iframe
                title="Location"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1766.7923880571755!2d85.32273299999997!3d27.706614!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39eb19a85bffffff%3A0x16cff0f3457de47!2sComputer%20Bazar!5e0!3m2!1sen!2snp!4v1750655468359!5m2!1sen!2snp"
                width="100%"
                height="350px"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactForm;
